export const IconType = {
  ARITHMETIC: "ARITHMETIC",
  ARROW: "ARROW",
};
